import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      d="M8.2 19.365c0-.452.366-.818.818-.818h11.166a.818.818 0 1 1 0 1.637H9.018a.819.819 0 0 1-.819-.819Z"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M20.52 11.464c.639-.64.639-1.676 0-2.315l-4.855-4.855a1.637 1.637 0 0 0-2.315 0l-9.97 9.97a1.31 1.31 0 0 0 0 1.852l3.587 3.588c.307.307.724.48 1.158.48h3.674l8.72-8.72ZM14.507 5.45l4.855 4.855-8.241 8.24H8.125L4.77 15.189l9.738-9.738Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      d="M19.718 9.08c.593.594.604 1.544.024 2.124l-5.886 5.886-6.65-6.651 5.885-5.886c.58-.58 1.53-.569 2.123.024l4.504 4.504Z"
    />
  </svg>
)
export default SvgComponent
